import { ApiParams, BaseClient, IActionResponse, IActionResult, IPagedResult, } from "../../../assets/utils/lib";
import { CommunityPlanDto, CommunityPlanViewDto, LookupDto, SearchDto } from "../../dto";

export class CommunityPlanClient extends BaseClient {
    routes = ["admin", "Community"];

    async getCommunityPlanAsync(id: string): Promise<CommunityPlanDto> {
        const actions: string[] = ["GetCommunityPlan"];
        const params: ApiParams[] = [new ApiParams("id", id, true)];

        const result: CommunityPlanDto = await this.getAsync<CommunityPlanDto>(actions, params);
        return result;
    }

    async getLookupsAsync(): Promise<{ community: LookupDto[]; plan: LookupDto[]; }> {
        const actions: string[] = ["GetCommunityPlanLookups"];
        const result = await this.getAsync<{ community: LookupDto[]; plan: LookupDto[]; }>(actions, []);
        return result;
    }

    async searchCommunityPlansAsync(payload: SearchDto | undefined): Promise<IPagedResult<CommunityPlanViewDto>> {
        const actions: string[] = ["SearchCommunityPlan"];
        const result: IPagedResult<CommunityPlanViewDto> = await this.postAsync<SearchDto, CommunityPlanViewDto, IPagedResult<CommunityPlanViewDto>>(actions, payload);
        return result;
    }

    async saveCommunityPlanAsync(payload: CommunityPlanDto): Promise<IActionResult<CommunityPlanDto>> {
        const actions: string[] = ["SaveCommunityPlan"];
        return await this.postAsync<CommunityPlanDto>(actions, payload);
    }

    async deActivateCommunityPlanAsync(id: string): Promise<IActionResponse> {
        const actions: string[] = ["DeActivateCommunityPlan"];
        const params: ApiParams[] = [new ApiParams("id", id, true)];
        return await this.getAsync(actions, params);
    }
}
